import { FieldError } from "react-hook-form";
import { Color } from "../../api/schemas";
import { Path } from "../../types/route";
import { SelectColor } from "./SelectColor";
import { useSelectColor } from "./hooks";

interface SelectColorContainerProps {
  colors: Color[];
  path: Path;
  setPath: (path: Path) => void;
  value: string;
  onChange: (color: string) => void;
  isDirty: boolean;
  error: FieldError | undefined;
}

export function SelectColorContainer({
  colors,
  path,
  setPath,
  value,
  onChange,
  isDirty,
  error,
}: SelectColorContainerProps) {
  const useSelectColorProps = useSelectColor({
    colors,
    path,
    selectedColorValue: value,
  });

  return (
    <SelectColor
      colors={colors}
      path={path}
      setPath={setPath}
      onClickColor={onChange}
      isNextButtonDisabled={!isDirty || error !== undefined}
      {...useSelectColorProps}
    />
  );
}
